import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import IntroBox from "./components/IntroBox";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import NoPage from "./utils/NoPage";
import ReactGA from "react-ga";

const App = () => {
  const [radius, setRadius] = useState("2");

  const handleInputChange = (e) => {
    setRadius(e.target.value);
  };

  useEffect(() => {
    ReactGA.initialize("UA-181651294-1");
    ReactGA.pageview(window.location.pathname);
  });

  return (
    <>
      <IntroBox />
      <Header radius={radius} />
      <Switch>
        <Route exact path="/">
          <Home handleInputChange={handleInputChange} radius={radius} />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route component={NoPage} />
      </Switch>
      <Footer />
    </>
  );
};

export default App;
